module.exports = __webpack_public_path__ + "static/media/outgoing-ring.7240df9a.mp3";